/*!

=========================================================
* Black Dashboard React v1.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/black-dashboard-react
* Copyright 2020 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/black-dashboard-react/blob/master/LICENSE.md)

* Coded by 
 * 
 * Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React from "react";

// reactstrap components
import {
  Button,
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  CardText,
  FormGroup,
  Form,
  Input,
  Row,
  Col,
} from "reactstrap";
import { useEffect } from 'react';
import { unregister } from "../Interceptor.js";
import { isExpired, decodeToken } from "react-jwt";
import { Alert } from 'reactstrap';
import { store, useGlobalState } from 'state-pool';


function UserProfile() {

    useEffect(() => {
        const MuiDrawer = document.querySelector(".sidebar");
        if (MuiDrawer == undefined && MuiDrawer == null)
            MuiDrawer.insertBefore(MuiDrawer);
        console.log(MuiDrawer);
        const MuiPaper = document.querySelector(".navbar-absolute");
        if (MuiPaper == undefined && MuiPaper == null)
            MuiPaper.insertBefore(MuiPaper);
        const MuiFooter = document.querySelector(".footer");
        if (MuiFooter == undefined && MuiFooter == null)
            MuiFooter.insertBefore(MuiFooter);
        /*const MuiDrawer = document.querySelector(".sidebar");
        if (MuiDrawer != undefined && MuiDrawer != null)
            MuiDrawer.parentNode.insertBefore(MuiDrawer);
        const MuiPaper = document.querySelector(".navbar-absolute");
        if (MuiPaper != undefined && MuiPaper != null)
            MuiPaper.parentNode.insertBefore(MuiPaper);
        const MuiFooter = document.querySelector(".footer");
        if (MuiFooter != undefined && MuiFooter != null)
            MuiFooter.parentNode.insertBefore(MuiFooter);*/
        var token = localStorage.getItem('token');
        var isMyTokenExpired = isExpired(token);
        var token = localStorage.setItem("tokenValidate", isMyTokenExpired);
        console.log(isMyTokenExpired);
        if (isMyTokenExpired) {
            window.location = "/"
        }
        login();
    }, []);

    const [empresa, setEmpresa] = React.useState("");
    const [email, setEmail] = React.useState("");
    const [nit, setNit] = React.useState("");
    const [direccion, setDireccion] = React.useState("");
    const [telefono, setTelefono] = React.useState("");
    const [TestId, setTestId] = React.useState("");
    const [visible, setVisible] = React.useState(false);

    const onDismiss = () => setVisible(false);


    const login = () => {

        var myHeaders = new Headers();

        var requestOptions = {
            method: 'GET',
            headers: myHeaders,
            redirect: 'follow'
        };

        const apiUrl = './api/Empresa/TraerEmpresa';
        fetch(apiUrl, requestOptions)
            .then(response => response.json())
            .then(

                data => {
                    var emp = data.basePresentation;
                    console.log(data)
                    setEmpresa(emp.Nombre);
                    setEmail(emp.Email);
                    setNit(emp.Nit);
                    setDireccion(emp.Direccion);
                    setTelefono(emp.Telefono);
                    setTestId(emp.SetTestId);
                }

            )
            .catch(error => {
                console.log('error', error);
                
            }
            )
    }

    const handleSetTestId = (e) => {
        console.log(e.target.value);
        setTestId(e.target.value);
        localStorage.setItem("settestid", e.target.value);
    }

    const guardarSetTestid = () => {
        var myHeaders = new Headers();

        var idset = localStorage.getItem("settestid");
        var raw = JSON.stringify(idset);

        var requestOptions = {
            method: 'POST',
            headers: myHeaders,
            body: raw,
            redirect: 'follow'
        };

        const apiUrl = './api/Auxiliar/ActualizarSetTestId';
        fetch(apiUrl, requestOptions)
            .then(response => response.json())
            .then(
                data => {
                    console.log(data)
                    if (data.codResponse == 1) {
                        setVisible(true);
                    }
                }

            )
            .catch(error => {
                console.log('error', error);

            }
            )
    }

  return (
    <>
      <div className="content">
        <Row>
          <Col md="4">
            <Card className="card-user">
              <CardBody>
                <CardText />
                <div className="author">
                  <div className="block block-one" />
                  <div className="block block-two" />
                  <div className="block block-three" />
                  <div className="block block-four" />
                  <a href="#pablo" onClick={(e) => e.preventDefault()}>
                    <img
                      alt="..."
                      className="avatar"
                      src={require("../assets/img/default-avatar.png").default}
                    />
                                      <h5 className="title">{ empresa }</h5>
                  </a>
                  <p className="description">Administrador</p>
                </div>
                <div className="card-description">
                                  { email }
                </div>
              </CardBody>
                      </Card>
                      <Card className="card-user">
                          <CardBody>
                              <CardText />
                              <div className="author">
                                  <h3 className="title" style={{  fontFamily: 'Hammersmith One' }}>Configurar el SetTestId</h3>
                              </div>
                              <div className="card-description">
                                  <FormGroup>
                                      <label>SetTestId Empresa</label>
                                      <Input
                                          onChange={handleSetTestId}
                                          value={TestId}
                                          placeholder="SetTestId"
                                          type="text"
                                          style={{ background: "#F7F7FF", border: "none", fontFamily: 'Hammersmith One' }}
                                      />
                                  </FormGroup>
                                  <Button variant="primary" style={{ fontFamily: 'Hammersmith One', width: "100%" }} onClick={guardarSetTestid}>Configurar SetTestId</Button>
                              </div>
                          </CardBody>
                      </Card>
                      <Alert color="primary" isOpen={visible} toggle={onDismiss}>
                          Se configuro el SetTestId correctamente.
                      </Alert>

                  </Col>

          <Col md="8">
                      <Card>
                          <CardHeader>
                              <h3 className="title" style={{ fontFamily: 'Hammersmith One', marginLeft: "15px", marginTop: "10px" }}>Perfil Empresa</h3>
                          </CardHeader>
                          <CardBody>
                              <Form style={{ margin: "15px", marginTop: "-10px" }}>
                                  <Row>
                                      <Col className="pr-md-1" md="5">
                                          <FormGroup>
                                              <label>Empresa</label>
                                              <Input
                                                  disabled
                                                  placeholder="Empresa"
                                                  defaultValue={empresa}
                                                  type="text"
                                                  style={{ background: "#F7F7FF", border: "none", fontFamily: 'Hammersmith One' }}
                                              />
                                          </FormGroup>
                                      </Col>
                                      <Col className="px-md-1" md="3">
                                          <FormGroup>
                                              <label>NIT</label>
                                              <Input
                                                  disabled
                                                  defaultValue={nit}
                                                  placeholder="Usuario"
                                                  type="text"
                                                  style={{ background: "#F7F7FF", border: "none", fontFamily: 'Hammersmith One' }}
                                              />
                                          </FormGroup>
                                      </Col>
                                      <Col className="pl-md-1" md="4">
                                          <FormGroup>
                                              <label htmlFor="exampleInputEmail1">
                                                  Correo
                                              </label>
                                              <Input disabled placeholder="mike@email.com" defaultValue={email} type="email" style={{ background: "#F7F7FF", border: "none", fontFamily: 'Hammersmith One' }} />
                                          </FormGroup>
                                      </Col>
                                  </Row>
                                  <Row>
                                      <Col className="pr-md-1" md="6">
                                          <FormGroup>
                                              <label>Primer Nombre</label>
                                              <Input
                                                  disabled
                                                  placeholder="Name"
                                                  type="text"
                                                  style={{ background: "#F7F7FF", border: "none", fontFamily: 'Hammersmith One' }}
                                              />
                                          </FormGroup>
                                      </Col>
                                      <Col className="pl-md-1" md="6">
                                          <FormGroup>
                                              <label>Apellido</label>
                                              <Input
                                                  disabled
                                                  placeholder="Last Name"
                                                  type="text"
                                                  style={{ background: "#F7F7FF", border: "none", fontFamily: 'Hammersmith One' }}
                                              />
                                          </FormGroup>
                                      </Col>
                                  </Row>
                                  <Row>
                                      <Col md="12">
                                          <FormGroup>
                                              <label>Dirección</label>
                                              <Input disabled
                                                  defaultValue={direccion}
                                                  placeholder="Home Address"
                                                  type="text"
                                                  style={{ background: "#F7F7FF", border: "none", fontFamily: 'Hammersmith One' }}
                                              />
                                          </FormGroup>
                                      </Col>
                                  </Row>
                                  <Row>
                                      <Col className="pr-md-1" md="4">
                                          <FormGroup>
                                              <label>Ciudad</label>
                                              <Input disabled
                                                  defaultValue="Bogota"
                                                  placeholder="City"
                                                  type="text"
                                                  style={{ background: "#F7F7FF", border: "none", fontFamily: 'Hammersmith One' }}
                                              />
                                          </FormGroup>
                                      </Col>
                                      <Col className="px-md-1" md="4">
                                          <FormGroup>
                                              <label>Pais</label>
                                              <Input disabled
                                                  defaultValue="Colombia-"
                                                  placeholder="Country"
                                                  type="text"
                                                  style={{ background: "#F7F7FF", border: "none", fontFamily: 'Hammersmith One' }}
                                              />
                                          </FormGroup>
                                      </Col>
                                      <Col className="pl-md-1" md="4">
                                          <FormGroup>
                                              <label>Codigo Postal</label>
                                              <Input disabled placeholder="ZIP Code" type="number" style={{ background: "#F7F7FF", border: "none", fontFamily: 'Hammersmith One' }} />
                                          </FormGroup>
                                      </Col>
                                  </Row>
                                  <Row>
                                      <Col md="8">
                                          <FormGroup>
                                              <label>Notas</label>
                                              <Input disabled
                                                  cols="80"
                                                  defaultValue={telefono}
                                                  placeholder="Here can be your description"
                                                  rows="4"
                                                  type="textarea"
                                                  style={{ background: "#F7F7FF", border: "none", fontFamily: 'Hammersmith One' }}
                                              />
                                          </FormGroup>
                                      </Col>
                                  </Row>
                              </Form>
                          </CardBody>
                          <CardFooter>

                          </CardFooter>
                      </Card>
                  </Col>
        </Row>
      </div>
    </>
  );
}

export default UserProfile;
